// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__I51a0","left":"StickyBox_left__344LV","right":"StickyBox_right__2WpLJ"};